/* eslint-disable no-nested-ternary */
import { Store } from '@website/Store';
import NextImage from 'next/image';
import { useRouter } from 'next/navigation';
import { useCallback, useContext, useState } from 'react';
import { Button, Col, Container } from 'react-bootstrap';
import { MdChat } from 'react-icons/md';
import AlisonAvatar from '../../../../public/images/team/alison.jpeg';
import MarkAvatar from '../../../../public/images/team/mark.jpg';
import MeganAvatar from '../../../../public/images/team/megan.jpg';
import AuthenticationModal from '../../auth/AuthenticationModal';

type AskForHelpProps = {
  link: string;
  tripTitle: string;
  type: 'footer' | 'in-content' | 'host-help';
};

export default function AskForHelp({ link, type, tripTitle }: AskForHelpProps) {
  const { push } = useRouter();

  const { state } = useContext(Store);
  const [showAuthModal, setShowAuthModal] = useState(false);

  const isUserLoggedIn = !!state.user.id;

  const handleAskForHelp = useCallback(() => {
    if (isUserLoggedIn) {
      push(`${link}?tripTitle=${tripTitle}`);
    } else {
      setShowAuthModal(true);
    }
  }, [isUserLoggedIn, link, push, tripTitle]);

  return (
    <>
      {type === 'footer' ? (
        <Button
          onClick={handleAskForHelp}
          variant={'outline-primary'}
          className="me-2"
        >
          <MdChat className="my-0" size="1.4em" />
          <span className="d-none d-md-inline-block ms-2">Ask a Question</span>
        </Button>
      ) : type === 'in-content' ? (
        <Container className="g-0 my-4">
          <Col xs={12} sm={12} md={8} className="p-3 rounded bg-light">
            <div className="d-flex flex-column flex-md-row align-items-center mb-4 ">
              <Col>
                <h5 className="mb-4 h-6">Have a question?</h5>
                <p>
                  If you have any questions about this trip or want to speak
                  with an expert, get in touch.
                </p>
                <p>We're ready to help.</p>
              </Col>
              <Col xs={12} md="auto" className="d-flex">
                {[AlisonAvatar, MarkAvatar, MeganAvatar].map((image, index) => (
                  <div
                    key={image.src}
                    style={{
                      // Add marginLeft is host image shown or the image is the second one
                      ...(index > 0 && {
                        marginLeft: '-25px',
                      }),
                    }}
                  >
                    <NextImage
                      className={`rounded-circle`}
                      width={75}
                      height={75}
                      alt="Team Images"
                      src={image}
                    />
                  </div>
                ))}
              </Col>
            </div>

            <div>
              <Button onClick={handleAskForHelp} className="mb-2 me-2">
                <MdChat className="my-0 me-2" size="1.4em" />
                Ask a question
              </Button>
            </div>
          </Col>
        </Container>
      ) : (
        <Button onClick={handleAskForHelp} className="mb-2 me-2">
          <MdChat className="my-0 me-2" size="1.4em" />
          Ask a question
        </Button>
      )}
      {showAuthModal && (
        <AuthenticationModal
          showModal={showAuthModal}
          onSuccess={async () => {
            // If user is logged in, redirect to the link
            push(`${link}?tripTitle=${tripTitle}`);
          }}
          onHide={() => setShowAuthModal(false)}
        />
      )}
    </>
  );
}
